import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className, isSavingsAndOffersFacet }) {
    
    return (
        <label className={`ns-checkbox ns-d-block ns-color-black ${className}`}>
            {value === "Specials & Clearance/Tool Specials" ? "Sale" : value === "Specials & Clearance" ? "Clearance" : value}
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark" />
        </label>
    )
}